import React from "react";
import { connect } from "react-redux";
import { courses } from "../../../redux/actions/courses";
import {
  Row,
  Col,
  Table,
  Input,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
  UncontrolledTooltip,
  Alert
} from "reactstrap";
import { BeatLoader } from "react-spinners";
import sortByPropText from "../../../helpers/content/manageSets/sortByPropText";
import AuthorCourseRow from "./AuthorCourseRow";

//for time being it is hardcoded
const AUTHOR_ID = "Pf5kopbedfcbEWAlW6LmfabZ5A13";

class AuthorCourses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      displayName: "",
      selectedCourseName: "",
      addingCourse: false,
      sortReverse: false
    };
    this.updateName = this.updateName.bind(this);
    this.updateDisplayName = this.updateDisplayName.bind(this);
  }

  componentDidMount() {
    this.props.fetchAllCourses(AUTHOR_ID);
  }
  handleChangeName = ({ target }) => this.setState({ name: target.value });
  handleChangeDisplayName = ({ target }) =>
    this.setState({ displayName: target.value });

  addCourse() {
    try {
      this.validateNewCourse();
      this.props.addCourse(AUTHOR_ID, this.state.name, this.state.displayName);

      this.setState({
        name: "",
        displayName: "",
        addingCourse: false,
        error: null
      });
    } catch (err) {
      switch (err) {
        case "NAME_EXIST_ERROR":
          this.showError("Course Name Already Exists");
          break;
        case "EMPTY_FIELD":
          this.showError("Both fields are required");
          break;
        default:
          console.log(err);
      }
    }
  }

  validateNewCourse() {
    const { courses } = this.props;
    if (this.state.name && this.state.displayName) {
      courses.forEach(course => {
        if (course.name.toUpperCase() === this.state.name.toUpperCase()) {
          throw "NAME_EXIST_ERROR";
        }
      });
    } else {
      throw "EMPTY_FIELD";
    }
  }
  showError(err) {
    this.setState({ error: err }, () => console.log(this.state.error));
    setTimeout(() => {
      this.setState({ error: null });
    }, 1500);
  }

  updateName(course, newName, updateState) {
    try {
      const { updateCourseName } = this.props;
      this.validateUpdateCourseName(course.id, newName);

      updateCourseName(course.id, newName);
    } catch (err) {
      switch (err) {
        case "NAME_EXIST_ERROR":
          this.showError("Course Name Already Exists");
          break;
        case "EMPTY_FIELD":
          this.showError("Both fields are required");
          break;
        default:
          console.log(err);
      }
      updateState({ name: course.name });
    }
  }
  updateDisplayName(course, newDisplayName, updateState) {
    try {
      const { updateCourseDisplayName } = this.props;
      this.validateUpdateCourseDisplayName(newDisplayName);
      updateCourseDisplayName(course.id, newDisplayName);
    } catch (err) {
      switch (err) {
        case "NAME_EXIST_ERROR":
          this.showError("Course Name Already Exists");
          break;
        case "EMPTY_FIELD":
          this.showError("Both fields are required");
          break;
        default:
          console.log(err);
      }

      updateState({ displayName: course.displayName });
    }
  }
  validateUpdateCourseName(courseId, newName) {
    const { courses } = this.props;
    if (newName) {
      courses.forEach(course => {
        if (
          course.name.toUpperCase() === newName.toUpperCase() &&
          course.id !== courseId
        ) {
          throw "NAME_EXIST_ERROR";
        }
      });
    } else {
      throw "EMPTY_FIELD";
    }
  }

  validateUpdateCourseDisplayName(displayName) {
    if (!displayName) {
      throw "EMPTY_FIELD";
    }
  }

  render() {
    let sortedCourses = [];
    const { courses } = this.props;
    if (courses) {
      sortedCourses = sortByPropText(courses, "name", this.state.sortReverse);
    }
    return (
      <React.Fragment>
        <Card className="author-courses-container">
          <Row className="">
            <Col xs="8">
              <h3 className="course-heading">Course Editor</h3>
            </Col>
            <Col xs="4">
              <div
                className="add-link"
                onClick={() => this.setState({ addingCourse: true })}
              >
                <a> Add New Course</a>
              </div>
            </Col>

            <CardBody>
              <Col>
                <React.Fragment>
                  <UncontrolledTooltip placement="top" target="NameTH">
                    The internal name of the course. Must be unique. E.g. "ACT
                    Mastery v2"
                  </UncontrolledTooltip>
                  <UncontrolledTooltip placement="top" target="DisplayNameTH">
                    The name of the course visible to users. E.g. "ACT Mastery".
                  </UncontrolledTooltip>
                  <UncontrolledTooltip placement="top" target="PublishedTH">
                    Whether or not this course is published (licensable and
                    accessible to users).
                  </UncontrolledTooltip>
                </React.Fragment>
                <Table>
                  <thead>
                    <tr>
                      <th id="PublishedTH">Published</th>
                      <th id="DisplayNameTH">Course Display Name </th>
                      <th
                        id="NameTH"
                        onClick={() =>
                          this.setState({
                            sortReverse: !this.state.sortReverse
                          })
                        }
                      >
                        Course Name{" "}
                        <i
                          className={`arrow-${
                            this.state.sortReverse ? "up" : "down"
                          }`}
                        />
                      </th>
                      <th id="PublishedTH">Edit Course</th>
                      <th id="LastModifiedTH">Last Modified</th>
                      <th id="ActionTH">Delete</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {!!this.state.error && (
                      <tr className="bg-white">
                        <td colSpan="12">
                          <Alert color="danger">{this.state.error}</Alert>
                        </td>
                      </tr>
                    )}
                    {this.state.addingCourse && (
                      <tr>
                        <td>
                          <i className="not-published-icon" />
                        </td>

                        <td>
                          {this.state.addingCourse ? (
                            <Input
                              className="course-input is-invalid"
                              name="quantity"
                              id="quantity"
                              type="text"
                              value={this.state.displayName}
                              placeholder="Enter Course Display Name"
                              form="addform"
                              onChange={event =>
                                this.handleChangeDisplayName(event)
                              }
                            />
                          ) : (
                            <h4>-</h4>
                          )}
                        </td>
                        <td>
                          {this.state.addingCourse ? (
                            <Input
                              className="course-input is-invalid"
                              id="name"
                              type="text"
                              value={this.state.name}
                              placeholder="Enter Course Name"
                              form="addform"
                              onChange={event => this.handleChangeName(event)}
                            />
                          ) : (
                            <h4>-</h4>
                          )}
                        </td>

                        <td>
                          {
                            <Button
                              onClick={() => this.addCourse()}
                              className="btn publish-btn"
                            >
                              Add Course
                            </Button>
                          }
                        </td>
                        <td>
                          <h4>-</h4>
                        </td>
                        <td>
                          {this.state.addingCourse ? (
                            <Button
                              onClick={() =>
                                this.setState({
                                  addingCourse: false,
                                  name: "",
                                  displayName: ""
                                })
                              }
                            >
                              Cancel
                            </Button>
                          ) : (
                            <h4>-</h4>
                          )}
                        </td>
                      </tr>
                    )}
                    {sortedCourses.map(course => {
                      return (
                        <AuthorCourseRow
                          course={course}
                          key={course.id}
                          changeName={this.updateName}
                          changeDisplayName={this.updateDisplayName}
                          
                        />
                      );
                    })}
                    {sortedCourses.length === 0 && (
                      <BeatLoader loading={true} />
                    )}
                  </tbody>
                </Table>
              </Col>
            </CardBody>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    courses: state.courses.courses
  };
};
export default connect(
  mapStateToProps,
  courses
)(AuthorCourses);



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorCourses.js